module.exports = __webpack_public_path__ + "media/images/site/valores-e6727b3d9b2b844c6056384b2201f3e8.jpg";